<template>
  <v-main>
    <template v-if="datatree.users && (!userdata.pay || !userdata.pay.pay)">
      <v-row
        align="center"
        justify="center">
        <v-col cols="12" sm="3">
          <v-img
            :src="not_found"></v-img>
        </v-col>
      </v-row>
    </template>
    <template v-if="userdata.pay && userdata.pay.stable" class="mb-12">
      <v-layout row>
        <v-flex xs12 sm12 md6 offset-md3>
          <v-container fluid>
            <br>
            <v-layout row>
              <v-flex xs5 class="ml-2">
                <div class="title  mb-2">Расчёт ЗП
                    <span v-if="userdata.name != user.name">
                      {{userdata.name}}
                    </span>
                </div>

                <c_zp
                  title="Оклад"
                  :comment="paylist.filter(el => el.SData.count > 0)
                        .map(el => `${el.shop} ${el.SData.count}с/${el.SData.hours}ч`)"
                  :sumcomment = "paylist.map(el => el.stable).filter(el => el > 0)"
                  :summ="paylist.map(el => el.stable).reduce((a,b) => a+b)"
                  ></c_zp>

                <c_zp
                  title="Личные продажи"
                  :comment="paylist.filter(el => el.PData.percent > 0)
                        .map(el => `${el.PData.percent}% от ${el.PData.selling}`)"
                  :sumcomment = "paylist.map(el => el.personal).filter(el => el > 0)"
                  :summ="paylist.map(el => el.personal).reduce((a,b) => a+b)"
                  ></c_zp>

                <c_zp
                  title="Бонус-рулоны"
                  :comment="paylist.filter(el => el.BRData.quantity > 0)
                        .map(el => `${el.shop} за ${el.BRData.quantity} шт.`)"
                  :sumcomment = "paylist.map(el => el.bonusroll).filter(el => el > 0)"
                  :summ="paylist.map(el => el.bonusroll).reduce((a,b) => a+b)"
                  ></c_zp>

                <c_zp
                  title="План магазина"
                  :comment="paylist.filter(el => el.extra > 0)
                        .map(el => `${el.shop} коэф-т ${el.extraC}`)"
                  :sumcomment = "paylist.map(el => el.extra).filter(el => el > 0)"
                  :summ="paylist.map(el => el.extra).reduce((a,b) => a+b)"
                  ></c_zp>

                <c_zp
                  title="Дневной план"
                  :comment="paylist.filter(el => el.DPData.quantity > 0)
                        .map(el => `${el.shop} смен - ${el.DPData.quantity}`)"
                  :sumcomment = "paylist.map(el => el.dailyplan).filter(el => el > 0)"
                  :summ="paylist.map(el => el.dailyplan).reduce((a,b) => a+b)"
                  ></c_zp>

                <c_zp
                  title="Средний чек"
                  :comment="paylist.filter(el => el.ACData.quantity > 0)
                        .map(el => `${el.shop} смен - ${el.ACData.quantity}`)"
                  :sumcomment = "paylist.map(el => el.avercheck).filter(el => el > 0)"
                  :summ="paylist.map(el => el.avercheck).reduce((a,b) => a+b)"
                  ></c_zp>

                <v-layout row class="ml-1 mb-2">
                  <v-flex xs6>
                    <div class="title">Итого</div>
                  </v-flex>

                  <v-flex xs5>
                    <div class="text-right title">
                      {{paylist.map(el => el.pay).reduce((a,b) => a+b) | money}}
                    </div>
                  </v-flex>

                  <div
                    class="blue-grey--text text-right font-weight-light"
                    v-if="userdata.correction">

                    корр. продаж {{paymain.PData.correction | money}}
                  </div>

                  <div
                    class=" subtitle-1 red--text"
                    v-if="userdata.addon.length > 0">
                    <span v-for="(el, idx) in userdata.addon" :key="idx+el">
                      {{addon[el]}}
                      <v-icon color="red"> sentiment_very_dissatisfied</v-icon>
                    </span>
                  </div>
                </v-layout>
              </v-flex>                            

              <v-flex xs5 class="ml-9" v-if="userdata.name">
                <!-- Личные продажи по всем магазинам-->
                <v-alert v-if="paymain.PData"
                  border="left"
                  colored-border
                  color="orangeDark"
                  elevation="2">

                  <p>
                    <v-icon>person</v-icon>
                    <span class="ml-3 blue-grey--text">{{userdata.grade}}</span>
                    <br>
                    {{paymain.PData.selling | money}}
                    <span v-if="paymain.PData.money2 > 0">/ {{paymain.PData.money2| money}}</span>
                    <v-progress-linear
                      :value="paymain.PData.selling / paymain.PData.money2 * 100"
                      :buffer-value="paymain.PData.selling / paymain.PData.money2 * 100"
                      stream
                      color="blueDark"></v-progress-linear>
                  </p>
                </v-alert>

                <!-- Личная эффективность для домашнего магазина-->
                <v-alert v-if="userdata &&
                         userdata.shopD == userdata.email"
                  border="left"
                  colored-border
                  color="orangeDark"
                  elevation="2" >

                  <p>
                    <v-icon>assistant_photo</v-icon>
                    <span class="ml-3 blue-grey--text">эффективность</span>
                    <br>
                    <span class="mr-6 blue-grey--text">личная</span>
                    <span
                      class="headline"
                      :class="userdata.personaleffectiv < 80  ? 'red--text' :
                          userdata.personaleffectiv < 90  ? 'orange--text' :
                          userdata.personaleffectiv < 100 ? 'black--text' :
                          'teal--text'">
                      {{`${userdata.personaleffectiv.toFixed()}%`}}
                    </span>
                    <br>
                    <span class="mr-12 blue-grey--text">план</span>
                    {{userdata.planmoney | money}}
                    <br>
                    <span class="mr-2 blue-grey--text">выполнен</span>
                    {{`${userdata.planpercent.toFixed()}%`}}
                    <br>
                    <span class="mr-6 blue-grey--text">прогноз</span>
                    {{`${userdata.prognoz.toFixed()}%`}}
                  </p>
                </v-alert>

                <!-- Текущий магазин -->
                <v-alert v-if="datatree.paysett"
                  border="left"
                  colored-border
                  color="orangeDark"
                  elevation="2" >

                  <p>
                    <v-icon>people</v-icon>
                    <span class="ml-3 blue-grey--text">{{datatree.ID}}</span>
                    <br>
                    <span>{{datatree.moneyI | money}}
                      <span v-if="datatree.planmoney">/ {{datatree.planmoney| money}}</span>
                    </span>
                    <v-progress-linear
                      :value="datatree.moneypercent"
                      :buffer-value="datatree.prognoz"
                      stream
                      :color="datatree.prognoz > 90 ? '#686F8A' : 'red'" ></v-progress-linear>
                    <span class="mr-2 blue-grey--text">выполнен</span>
                    {{`${datatree.moneypercent.toFixed()}%`}}
                    <br>
                    <span class="mr-6 blue-grey--text">прогноз</span>
                    {{`${datatree.prognoz.toFixed()}%`}}
                    <br>
                  </p>
                  <div v-if="shift.day">
                    <div class="blue-grey--text">смена</div>
                    <v-progress-circular
                      class="ml-5"
                      :rotate="180"
                      :size="140"
                      :width="15"
                      :value="shift.planmoney && fact > 0 ? fact / shift.planmoney * 100 : 0"
                      color="blueGrey" >
                        факт {{fact | money}}<br>
                        план {{shift.planmoney | money}}
                    </v-progress-circular>
                  </div>
                </v-alert>

        <!-- Бонус рулоны -->
                <v-alert v-if="datatree.plan_ss"
                  border="left"
                  colored-border
                  color="orangeDark"
                  elevation="2" >

                  <div>
                    <span class="blue-grey--text">Бонус-рулонов</span>
                    {{userdata.pay.BRData.balance}}
                    <span class="blue-grey--text">/{{datatree.plan_ss}}</span>
                  </div>
                </v-alert>

                <v-alert v-if="averageData"
                  border="left"
                  colored-border
                  color="orangeDark"
                  elevation="2" >
                
                  <div>
                    <span class="subtitle-1">Средняя эффективность:</span>
                    {{averageData.effectiv ? averageData.effectiv + '%' : ''}}
                  </div>

                   <div>
                    <span class="subtitle-1">Средний штрафной балл:</span>
                    {{averageData.points}}
                  </div>
                </v-alert>

                <v-list v-if="userdata.points.length > 0">
                  <div class="subtitle-1 ml-1 mb-2 red--text"
                    >Штрафные баллы:
                  </div>
                  <v-list-item-group
                    v-for="(point, idx) in userdata.points"
                    :key="idx+point"
                    color="red">
                    <v-icon color="red"> clear </v-icon>{{points[point]}} {{point.comment}}
                  </v-list-item-group>
                </v-list>
              </v-flex>
            </v-layout>
             
            <template v-if="userdata.shiftOpen">
              <v-timeline dense clipped>
                <template
                  v-for="(smena, idx1) in userdata.shift.slice().reverse().filter(el => el.status == 'open')">
                  <c_smena
                  v-bind:key="idx1+smena.day"
                  v-bind:smena="smena"
                  v-bind:averdata="userdata.pay.ACData"
                  v-bind:dpdata="userdata.pay.DPData"
                  v-bind:settings="datatree.paysett"
                  :coin="coin"
                  ></c_smena>
                  <template>
                    <c_sale v-for="(sale, idx2) in smena.selling.slice().reverse()"
                    :key="idx2+Math.random()"
                    v-bind:sale="sale"
                    v-bind:brdata="userdata.pay.BRData"
                    :coin="coin"
                    ></c_sale>
                  </template>
                </template>
              </v-timeline>
            </template>
          </v-container>
        </v-flex>
      </v-layout> 
    </template>

  </v-main>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'

const c_zp =  {
props: ['title', 'comment', 'summ', 'sumcomment'],
template:`
  <v-layout row class="ml-1 mb-2" v-if="summ > 0">
    <v-flex xs8>
    <div>{{title}}</div>
    <div class="blue-grey--text font-weight-light ml-2" v-for="com in comment">
      {{com}}
    </div>
    </v-flex>
    <v-flex xs3>
      <div class="text-right">
      {{summ | money}}
      </div>
      <div class="blue-grey--text text-right font-weight-light" v-for="sm in sumcomment">
      {{sm | money}}
      </div>
    </v-flex>
  </v-layout>
`
};

  const c_smena = {
  props: ['smena', 'averdata', 'dpdata', 'settings', 'coin'],
  template:  `
    <v-timeline-item
    fill-dot
    class="mt-6"
    color="#F39314"
    large
    >
    <template v-slot:icon>
      <span class="white--text" v-if="dpdata[smena.day] && dpdata[smena.day].plan">
      {{dpdata[smena.day].fact > 0 ? (dpdata[smena.day].fact / dpdata[smena.day].plan * 100).toFixed() : 0}}%</span>
    </template>
    <v-row justify="space-between">
      <v-col cols="7">
      <b>{{smena.dayweek}}, {{smena.day}}</b>
        <span class="ml-4 blue-grey--text" v-if="settings.avercheck">
        <v-icon class="blue-grey--text">more_horiz</v-icon>ср.чек {{smena.avercheck2 | money}}
        </span>
      <v-img v-if="averdata && averdata[smena.day]"
          position="left"
          contain
          height="20px"
          :src="coin"
          > 
          <span class="ml-7 orange--text">бонус за ср.чек {{averdata[smena.day]}} ₽</span></v-img>
      <v-img v-if="dpdata[smena.day] && dpdata[smena.day].money"
          position="left"
          contain
          height="20px"
          :src="coin"
          > 
          <span class="ml-7 orange--text"> бонус за план {{dpdata[smena.day].money}} ₽</span></v-img>

      </v-col>
      <v-col class="text-right" cols="4"><b>{{smena.sellingMoney | money}}</b> ₽</v-col>
      <v-col class="text-left" cols="1">
      </v-col>
    </v-row>

    </v-timeline-item>
        `
  };


  const c_sale = {
  props: ['sale', 'brdata', 'coin'],
  name: c_sale,
  template:  ` 
    <v-timeline-item
    v-bind:color="sale.quantity < 0 ? 'red' : sale.bonus ? '#F39314' : '#686F8A'"
    small
    >
    <template v-slot:icon v-if="sale.bonus" >
      <span class="white--text">₽</span>
    </template>
    <v-row justify="space-between">
      <v-col cols="7">
      <div v-if="!sale.article">{{sale.name}}</div>
      <div>{{sale.article}}</div>
      <div>
        <span v-if="sale.product" class="blue-grey--text">
          {{sale.product.ТорговаяМарка}} {{sale.product.Коллекция}}
        </span>
      </div>
      <div v-if="brdata && brdata.money[sale.day] && sale.quantityB">
          <v-img
          position="left"
          contain
          height="20px"
          :src="coin"
          >
          <span class="ml-7 orange--text">
          бонус {{sale.quantityB * brdata.money[sale.day]}} ₽</span></v-img>
      </div>
      </v-col>
      <v-col class="text-right" cols="4">
      <div>{{sale.money | money}} ₽</div>
      <div class="blue-grey--text">{{sale.quantity}} x {{sale.price | money}}</div>
      </v-col>
      <v-col class="text-left" cols="1">
      </v-col>
    </v-row>
    </v-timeline-item>
        `
  };

export default {
name: 'State',
components: {c_zp, c_smena, c_sale},
props: ['user', 'shop'],
data: () => ({
  datatree: {},
  addon: {"offence": "штрафные баллы",
          "efficiency": "низкая эффективность"},
  proc_plan_now: 98,
  points: [],
  dateT: new Date(new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()),
}),

computed: {

  ...mapState(['not_found', 'coin', 'aver', 'date', 'domen']),

  averageData: function () {
    return this.aver[this.userdata.id];
  },

  userID: function () {
    let userID = '';
    if (this.$route.params.userid) userID = this.$route.params.userid;
    else userID = this.user.id;
    return userID;
  },

  userdata: function () {
    if (!this.datatree.users) return {};
    for (let i=0; i<this.datatree.users.length; i++) {
      if (this.datatree.users[i].id == this.userID)
        return this.datatree.users[i];
    }
    return {}
  },

  paymain: function () {
    if (Object.keys(this.paylist).length != 0) {
      let paymain = this.paylist.filter((el) => el.PData.selling > 0);
      if (Object.keys(paymain).length != 0) return paymain[0];
    }
    return {};
  },

  paylist: function () {
    if (Object.keys(this.userdata).length != 0) {
      let paylist = this.userdata.payOther.map((el) => el);
      paylist.unshift(this.userdata.pay);
      return paylist;
    }
    return [];
  },

  shift: function() {
    if (Object.keys(this.userdata).length == 0) return {};
    for (let i=0; i<this.userdata.shift.length; i++) {
      if (String(new Date(this.userdata.shift[i].dateFull.datetime)
                 ) == String(this.dateT)) {
        return this.userdata.shift[i];
      }
    }
    return {};
  },

  fact: function() {
    if (Object.keys(this.shift).length == 0) return 0;
    var fact = 0;
    for (let i=0; i<this.datatree.users.length; i++) {
      for (let j=0; j<this.datatree.users[i].shift.length; j++) {
        if (String(new Date(
              this.datatree.users[i].shift[j].dateFull.datetime)
                   ) == String(this.dateT)) {
          fact += this.datatree.users[i].shift[j].sellingMoney;
        }
      }
    }
    return fact;
  }    
},

methods: {

  async datauser (){
    // window.console.log(this.user, this.shop);
    if (!this.user.id || !this.shop) return;
    this.datatree = {};
    return axios.post(this.domen + '/service/datauser', {
      'year': new Date(this.date).getFullYear(),
      'month': new Date(this.date).getMonth() + 1,
      'shopID': this.shop
    }).then(res => res.data)
      .then(json => this.datatree = json['response'])
  }
  
},

watch: {

  date () {
    this.datauser();
  },

  shop () {
    this.datauser();
  }

},

created: function() {
  // window.console.log('!!!');
  this.datauser();
}

}
</script>
